module.exports = __webpack_public_path__ + "static/media/open.0e8ee229.png";